var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-dark text-center py-2"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/img/logo.svg","width":"150","height":"34","alt":"Logo Bike Registrada"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }